module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page013"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_1"
    }
  }, [_vm._v("BASICS")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_014"
    }
  }, [_vm._v("Baguette   "), _c('span', {
    staticClass: "page013_2a"
  }, [_vm._v("page 14")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_016"
    }
  }, [_vm._v("Brioches   "), _c('span', {
    staticClass: "page013_3a"
  }, [_vm._v("page 16")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_018"
    }
  }, [_vm._v("Apricot croissants   "), _c('span', {
    staticClass: "page013_4a"
  }, [_vm._v("page 18")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_020"
    }
  }, [_vm._v("Aïoli   "), _c('span', {
    staticClass: "page013_5a"
  }, [_vm._v("page 20")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_022"
    }
  }, [_vm._v("Vegetable stock   "), _c('span', {
    staticClass: "page013_6a"
  }, [_vm._v("page 22")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_024"
    }
  }, [_vm._v("Olive paste   "), _c('span', {
    staticClass: "page013_7a"
  }, [_vm._v("page 24")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_026"
    }
  }, [_vm._v("Provençal pesto   "), _c('span', {
    staticClass: "page013_8a"
  }, [_vm._v("page 26")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_026"
    }
  }, [_vm._v("Vinaigrette   "), _c('span', {
    staticClass: "page013_9a"
  }, [_vm._v("page 26")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/page_028"
    }
  }, [_vm._v("Fromage frais   "), _c('span', {
    staticClass: "page013_10a"
  }, [_vm._v("page 28")])])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page013_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/page_030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Béchamel sauce   "), _c('span', {
    staticClass: "page013_11a"
  }, [_vm._v("page 30")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e8ce094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_013.vue
// module id = 93
// module chunks = 0